<template>
        <b-container class="wrapper" fluid>
            <b-row class="section body white" align-h="center">
                <b-col cols="12" md="11" xl="8">
                    <b-row align-h="between">
                        <b-col class="left" cols="12" md="6" xl="6">
                            <a href="https://ozmo.mx"><img class="logo" alt="Ozmo logo" src="../../assets/ozmo_logo.svg"></a>
                        </b-col>
                        <b-col class="right d-none d-sm-block" md="6" xl="6">
                            <a href="https://www.linkedin.com/company/ozmo-futures-design" target="_blank"><div class="icon"><font-awesome-icon :icon="['fab', 'linkedin-in']" /></div></a>
                            <a href="https://twitter.com/OzmoFutures" target="_blank"><div class="icon"><font-awesome-icon :icon="['fab', 'twitter']" /></div></a>
                            <a href="https://www.instagram.com/ozmofutures/" target="_blank"><div class="icon"><font-awesome-icon :icon="['fab', 'instagram']" /></div></a>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col cols="12" md="11" xl="8">
                    <b-row>
                        <b-col cols="12" md="12" xl="12">
                            <h3>Algunos cambios son más complicados de navegar que otros... <span class="bold">¿Cómo enfrentamos las organizaciones la crisis por Covid-19 en México?</span></h3>
                        </b-col>
                    </b-row>
                    <b-row align-v="center">
                        <b-col cols="12" md="6" xl="6">
                            <p>En Ozmo nos dimos a la tarea de escuchar a líderes y tomadores de decisión de diversas empresas mexicanas; desde bancos y grandes cadenas de tiendas departamentales, hasta pequeñas empresas y emprendimientos.</p>
                            <p>Buscamos entender los retos a los que se están enfrentando, sus estrategias para reaccionar ante la contingencia y las oportunidades que vislumbran en el corto, mediano y largo plazo.</p>
                            <p>Nuestro objetivo es integrar sus experiencias con el conocimiento de los expertos y brindar perspectivas que nos permitan hacer sentido de estos retos y prepararnos para el futuro que viene.</p>
                        </b-col>
                        <b-col cols="12" md="6" xl="6">
                            <div class="mask2"></div>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12" md="12" xl="12">
                            <h1>¿Cómo prepararnos para lo que nos depara el futuro?</h1>
                            <p>En Ozmo ayudamos a las organizaciones a <span class="bold">transformarse, a diseñar su futuro y a accionar el cambio</span>. Como consultores en transformación estratégica nuestro enfoque está en:</p>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12" md="6" xl="6">
                            <b-row class="ozmo-bullet" align-v="center" align-h="center">
                                <b-col cols="2" md="2" xl="2"><div class="head blue mx-auto">01</div></b-col>
                                <b-col cols="10" md="10" xl="10" class="text">Crear sentido a partir<br> de la complejidad</b-col>
                            </b-row>
                            <p>Observamos a las personas, las organizaciones y sus interacciones, y conectamos los puntos para entender de dónde surge su realidad y cómo transformarla.</p>
                        </b-col>
                        <b-col cols="12" md="6" xl="6">
                            <b-row class="ozmo-bullet" align-v="center" align-h="center">
                                <b-col cols="2" md="2" xl="2"><div class="head green mx-auto">02</div></b-col>
                                <b-col cols="10" md="10" xl="10" class="text">Imaginar futuros<br> deseables y los accionamos</b-col>
                            </b-row>
                            <p>Colaboramos con los equipos para desarrollar las capacidades y crear los contextos necesarios para poner en marcha aquello que imaginamos para el futuro de las organizaciones.</p>
                        </b-col>
                    </b-row>
                    <b-row align-v="center">
                        <b-col class="d-none d-sm-block" md="4" xl="4">
                            <div class="mask mx-auto"></div>
                        </b-col>
                        <b-col class="callToAction" cols="12" md="8" xl="8">
                            <h3>Hacemos que el cambio ocurra por diseño, no por casualidad</h3>
                            <p><b-button @click="launch" class="ozmo-btn">Descarga el reporte</b-button></p>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col cols="12" md="11" xl="8">
                    <b-row>
                        <b-col cols="12" md="12" xl="12">
                            <p><span class="colored">Todo está cambiando</span> (y así es como debería ser). Después de todo, la vida es la creación constante de uno mismo, <span class="colored">la vida es cambio</span>, cuando ese proceso se detiene, morimos. Lo que debería de preocuparnos no es el cambio, sino la <span class="colored">ausencia de cambio</span>.</p>
                            <p class="footnote">(Basado en el concepto de autopoiesis y las ideas de Humberto Maturana, filósofo, biólogo y epistemólogo chileno)</p>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
        </b-container>
</template>

<script>

import * as typeformEmbed from '@typeform/embed';

import { eventBus } from '../../main'

export default {
    data() {
        return{}
    },
    metaInfo() {
        return {
            title: 'Covid-19 | Ozmo ',
            meta: [
                {name: 'description', content: 'Ozmo ante el Covid-19'},
+               {name: 'keywords', content: 'Covid-19, consultora en innovación estratégica, consultora de innovación, agencia de transformación estratégica, consultora de cultura organizacional, consultoría en transformación para empresas, consultoría en cultura organizacional, proveedores de design thinking, agencias de investigación de usuarios, talleres para diseñar experiencias, consultoras con experiencia en área de capital humano, consultoras en innovación con experiencia sector financiero, agencia de innovación empresarial'},
                {name: 'robots', content: 'index,follow'},
                {name: 'viewport', content: 'width=device-width,initial-scale=1,user-scalable=no' },
                {charset: 'utf-8' },
                {property: 'og:title', content: 'Covid-19'},
+               {property: 'og:site_name', content: 'Ozmo | Diseño de futuros'},
+               {property: 'og:description', content: 'Ozmo ante el Covid-19'},
                {property: 'og:type', content: 'website'},
                {property: 'og:image', content: 'https://s3-us-west-2.amazonaws.com/cdn.ozmo.mx/ozmo_coral.png'}
            ]
        }
    },
    methods: {
        goto(navigation) {
            eventBus.$emit('gotoNavigation', navigation)
        },
        launch() {
            typeformEmbed.makePopup(
                'https://ozmomx.typeform.com/to/C326sA',
                {
                    mode: 'drawer_right',
                    autoOpen: true,
                    autoClose: 15,
                    hideScrollbars: true,
                    onSubmit: function () {}
                }
                )
        }
    }
}
</script>

<style lang="stylus" scoped>


/***********************
    COLORING STYLES
***********************/

.white
    --template-color $ozmo-coral
    background-color #FFFFFF

    .icon
        background-color $ozmo-coral
        color #FFFFFF

    h1,h2,h2 .bold
        color $ozmo-coral

    p
        color $ozmo-gray

        .colored
            color $ozmo-blue

        .bold
            color $ozmo-gray

    .ozmo-bullet
        .text
            color $ozmo-coral

    .ozmo-btn
        border 2px solid $ozmo-coral
        background-color $ozmo-coral
        color #FFFFFF

    .mask2
        box-shadow 175px 0px 0px $ozmo-coral

.red
    --template-color $ozmo-blue
    background-color $ozmo-coral

    .logo
        filter brightness(0) invert(1)

    .icon
        background-color #FFFFFF
        color $ozmo-coral

    h1,h2,h2 .bold
        color #FFFFFF

    p
        color #FFFFFF

        .colored
            color $ozmo-blue

        .bold
            color #FFFFFF

    .ozmo-bullet
        .text
            color #FFFFFF

    .ozmo-btn
        border 2px solid #FFFFFF
        background-color #FFFFFF
        color $ozmo-coral

    .mask2
        box-shadow 175px 0px 0px $ozmo-blue



.gray
    --template-color $ozmo-coral
    background-color $ozmo-gray

    .logo
        filter brightness(0) invert(1)

    .icon
        background-color #FFFFFF
        color $ozmo-gray

    h1,h2,h2 .bold
        color #FFFFFF

    p
        color #FFFFFF

        .colored
            color $ozmo-green

        .bold
            color #FFFFFF

    .ozmo-bullet
        .text
            color #FFFFFF

    .ozmo-btn
        border 2px solid #FFFFFF
        background-color #FFFFFF
        color $ozmo-gray

    .mask2
        box-shadow 175px 0px 0px $ozmo-coral





/***********************
    TEMPLATE STYLES
***********************/

.wrapper
    width 100vw
    height 100vh
    overflow-x hidden
    overflow-y scroll

.logo
    width 144px

.icon
    width 32px
    height 32px
    border-radius 32px
    line-height 32px
    background-color $ozmo-coral
    text-align center
    margin-left 2rem
    float right
    txt_style($worksans-m, 20px, #FFFFFF)

.mask
    margin-top 10rem
    width 250px
    height 250px
    border-radius 300px
    background-image url('../../assets/landings/covid-19/photo-1568952433726-3896e3881c65.jpg')
    background-repeat no-repeat
    background-position center
    background-size 400px

.mask2
    width 350px
    height 350px
    border-radius 350px
    background-image url('../../assets/landings/covid-19/photo-1523240795612-9a054b0db644.jpg')
    background-repeat no-repeat
    background-position center
    background-size 700px

.ozmo-bullet
    margin-top 5rem

    .head
        width 58px
        height 58px
        line-height 58px
        border-radius 50px
        text-align center
        txt_style($archia-m, 16px, #FFFFFF)

    .head.blue
        background-color $ozmo-blue

    .head.green
        background-color $ozmo-green

    .text
        txt_style($worksans-r, 16px, $ozmo-coral)

.body
    padding 10rem 0

img
    width 100%

h1
    margin-top 10rem
    txt_style($archia-m, 48px, $ozmo-coral)

h2
    margin-top 10rem
    txt_style($archia-r, 48px, $ozmo-coral)

    .bold
        txt_style($archia-m, 48px, $ozmo-coral)
h3
    margin-top 10rem
    txt_style($archia-r, 40px, $ozmo-coral)

    .bold
        txt_style($archia-m, 40px, $ozmo-coral)        

p
    margin-top 5rem
    txt_style($worksans-r, 18px, $ozmo-gray)

    .colored
        txt_style($worksans-r, 18px, $ozmo-blue)

    .bold
        txt_style($worksans-b, 18px, $ozmo-gray)

.footnote
        txt_style($worksans-r, 16px, $ozmo-gray)

.ozmo-btn
    txt_style($worksans-r, 22px, $ozmo-coral)
    line-height 44px


@media (min-width 768px) and (max-width 1200px)
    .mask
        width 200px
        height 200px
        background-size 300px

    .mask2
        width 300px
        height 300px
        background-size 600px
        box-shadow 150px 0 0 var(--template-color) !important

@media (max-width 767px)

    .mask2
        width 200px
        height 200px
        background-size 400px
        margin 10rem auto 0 auto
        box-shadow 100px 0 0 var(--template-color) !important
        position relative
        left -50px

    h1,h2,h2,h3,h3 .bold, h3.colored
        font-size 32px

    p, p .colored, p .bold
        font-size 16px
    .footnote
        font-size 14px  

    .callToAction
        text-align center

@media (max-width 320px)

    .mask2
        width 200px
        height 200px
        background-size 400px
        margin 10rem auto 0 auto
        box-shadow 100px 0 0 var(--template-color) !important
        position relative
        left -50px

    h1,h2,h2,h3,h3 .bold, h3.colored
        font-size 30px

    p, p .blue, p .bold, p .colored
        font-size 14px
    .footnote
        font-size 12px  

    .callToAction
        text-align center

    .footnote
        font-size 12px


</style>